export default __webpack_public_path__ + "static/media/XamSketch928.03bcc6d0.jpg";